<template>
  <div>
    <template v-if="isRespondido">
      <px-matriz-preco v-if="hasPreco" :produto="produto"
                      :hide-icms="hideIcms" :show-difal="showDifal" :show-ipi="showIpi"
                      :show-percentual-icms="showPercentualIcms"/>
      <px-matriz-preco-target :show-preco-target="showPrecoTarget" :produto="produto"/>
      <px-matriz-prazo-pagamento v-if="hasPrazo" :produto="produto"></px-matriz-prazo-pagamento>
      <px-matriz-frete v-if="hasFrete" :produto="produto"></px-matriz-frete>
      <span v-if="hasEspecificacao">
        {{ produto.produto.especificacaoProduto }}
      </span>
    </template>
    <template v-else-if="isNaoRespondido">
      -
    </template>
    <template v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="error" large v-on="on">
            mdi-close-circle
          </v-icon>
        </template>
        <span>{{ situacao }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import PxMatrizFrete from '@/modules/cotacao/resposta/matriz/components/PxMatrizFrete.vue';
import PxMatrizPreco from './PxMatrizPreco.vue';
import PxMatrizPrazoPagamento from './PxMatrizPrazoPagamento.vue';
import PxMatrizPrecoTarget from './PxMatrizPrecoTarget.vue';

export default {
  props: {
    produto: Object,
    hasPreco: Boolean,
    hasPrazo: Boolean,
    hasFrete: Boolean,
    hasEspecificacao: Boolean,
    hideIcms: Boolean,
    showDifal: Boolean,
    showIpi: Boolean,
    showPercentualIcms: Boolean,
    showPrecoTarget: Boolean,
  },
  computed: {
    isRespondido() {
      return this.produto.produto.situacao === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isNaoRespondido() {
      return this.produto.produto.situacao
        === SituacaoRespostaCotacaoProduto.keys.NAO_RESPONDIDA.key;
    },
    situacao() {
      return SituacaoRespostaCotacaoProduto.keys[this.produto.produto.situacao].description;
    },
  },
  components: {
    PxMatrizPreco,
    PxMatrizPrazoPagamento,
    PxMatrizFrete,
    PxMatrizPrecoTarget,
  },
};
</script>
